document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-muse-dialog]');
  if (trigger) {
    const dialog = document.getElementById(trigger.dataset.museDialog);
    if (dialog && !dialog.open) dialog.showModal();
  }
  const close = event.target.closest('[data-muse-close]');
  if (close) close.closest('dialog')?.close();
  if (event.target.matches('dialog.muse-pdp__drawer')) {
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  }
});
